import { FontFamily } from '../tokentypes';
import { fromConst } from './base';
function createFontFamily(rawData) {
  return new FontFamily(rawData.fontFamily, rawData.fontWeight);
}
export function fontFamilyConst(rawData, tokenOptions) {
  return fromConst(createFontFamily, rawData, tokenOptions);
}
//# sourceMappingURL=fontFamily.js.map